import React from 'react';

import DashboardTopBarContent from './DashboardTopBarContent';
import ConfirmLogoutModal, {
  useOpenConfirmLogoutModal,
} from './ConfirmLogoutModal';
import InviteUserToEventModal, {
  useOpenInviteUserToEventModal,
} from './InviteUserToEventModal';

const DashboardTopBar = () => {
  const {
    open: isOpenedConfirmLogoutModal,
    openModal: onOpenConfirmLogoutModal,
    closeModal: onCloseConfirmLogoutModal,
  } = useOpenConfirmLogoutModal();
  const {
    open: isOpenedInviteUserModal,
    openModal: openInviteUserModal,
    closeModal: closeInviteUserModal,
  } = useOpenInviteUserToEventModal();

  return (
    <>
      <DashboardTopBarContent
        onOpenConfirmLogoutModal={onOpenConfirmLogoutModal}
        onOpenInviteUserModal={openInviteUserModal}
      />
      <ConfirmLogoutModal
        open={isOpenedConfirmLogoutModal}
        onClose={onCloseConfirmLogoutModal}
      />
      {isOpenedInviteUserModal ? (
        <InviteUserToEventModal
          open={isOpenedInviteUserModal}
          onClose={closeInviteUserModal}
        />
      ) : null}
    </>
  );
};

export default DashboardTopBar;
